import { render, staticRenderFns } from "./AdminManage.vue?vue&type=template&id=5aded384&scoped=true&"
import script from "./AdminManage.vue?vue&type=script&lang=js&"
export * from "./AdminManage.vue?vue&type=script&lang=js&"
import style0 from "./AdminManage.vue?vue&type=style&index=0&id=5aded384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aded384",
  null
  
)

export default component.exports